import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Play } from '../../res/play.svg';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupFederationOffices from '../../popups/PopupFederationOffices';
import PopupFederationSocial from '../../popups/PopupFederationSocial';
import PopupFederationCoop from '../../popups/PopupFederationCoop';
import PopupFederationProcivis from '../../popups/PopupFederationProcivis';
import PopupFederationAssociations from '../../popups/PopupFederationAssociations';
import PopupInterview from '../../components/PopupInterview';
import Card from '../../components/Card';

import styles from './styles';

class B5Federations extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}>
          <div className={classes.blur}></div>
        </div>
        <div className={classes.greenCurve}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data, baseUrl, onPopup } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.main}>
          <div className={`${classes.card1} ${classes.cardMobile}`}>
            <Card
              data={data}
              title={parse(data.blocks.b5federations.card1.title)}
              color="green"
              imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card1.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupFederationOffices', true)}>
                  {parse(data.blocks.b5federations.card1.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="black" icon={<Play />} onClick={() => onPopup('popupItvMarcelRogemont', true)}>
                  {parse(data.blocks.b5federations.card1.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card2} ${classes.cardMobile}`}>
            <Card
              data={data}
              title={parse(data.blocks.b5federations.card2.title)}
              color="green"
              imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card2.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupFederationSocial', true)}>
                  {parse(data.blocks.b5federations.card2.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="black" icon={<Play />} onClick={() => onPopup('popupItvValerieFournier', true)}>
                  {parse(data.blocks.b5federations.card2.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card3} ${classes.cardMobile}`}>
            <Card
              data={data}
              title={parse(data.blocks.b5federations.card3.title)}
              color="green"
              imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card3.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupFederationCoop', true)}>
                  {parse(data.blocks.b5federations.card3.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon
                  color="black"
                  icon={<Play />}
                  onClick={() => onPopup('popupItvMarieNoelleLienemann', true)}
                >
                  {parse(data.blocks.b5federations.card3.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card4} ${classes.cardMobile}`}>
            <Card
              data={data}
              title={parse(data.blocks.b5federations.card4.title)}
              color="green"
              imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card4.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="black" icon={<Add />} onClick={() => onPopup('popupFederationProcivis', true)}>
                  {parse(data.blocks.b5federations.card4.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="black" icon={<Play />} onClick={() => onPopup('popupItvYannickBorde', true)}>
                  {parse(data.blocks.b5federations.card4.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card5} ${classes.cardMobile}`}>
            <Card
              data={data}
              title={parse(data.blocks.b5federations.card5.title)}
              color="green"
              imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card5.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon
                  color="black"
                  icon={<Add />}
                  onClick={() => onPopup('popupFederationAssociations', true)}
                >
                  {parse(data.blocks.b5federations.card5.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="black" icon={<Play />} onClick={() => onPopup('popupItvDenisRambaud', true)}>
                  {parse(data.blocks.b5federations.card5.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data, baseUrl, popupsState, onPopup } = this.props;
    const mainTitle = parse(data.blocks.b5federations.mainTitle);
    const subtitle = parse(data.blocks.b5federations.subtitle);
    return (
      <div className={classes.blockContainer}>
        <Typography variant="h1" color="secondary" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        <Typography variant="body1" color="secondary" className={classes.subtitle}>
          {subtitle}
        </Typography>
        {this.renderBackground()}
        {this.renderContent()}
        <PopupFederationOffices
          data={data}
          open={!!popupsState.popupFederationOffices}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupFederationOffices', false)}
        ></PopupFederationOffices>
        <PopupFederationSocial
          data={data}
          open={!!popupsState.popupFederationSocial}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupFederationSocial', false)}
        ></PopupFederationSocial>
        <PopupFederationCoop
          data={data}
          open={!!popupsState.popupFederationCoop}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupFederationCoop', false)}
        ></PopupFederationCoop>
        <PopupFederationProcivis
          data={data}
          open={!!popupsState.popupFederationProcivis}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupFederationProcivis', false)}
        ></PopupFederationProcivis>
        <PopupFederationAssociations
          data={data}
          open={!!popupsState.popupFederationAssociations}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupFederationAssociations', false)}
        ></PopupFederationAssociations>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationOffices}
          open={!!popupsState.popupItvMarcelRogemont}
          onClose={() => onPopup('popupItvMarcelRogemont', false)}
        ></PopupInterview>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationSocial}
          open={!!popupsState.popupItvValerieFournier}
          onClose={() => onPopup('popupItvValerieFournier', false)}
        ></PopupInterview>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationCoop}
          open={!!popupsState.popupItvMarieNoelleLienemann}
          onClose={() => onPopup('popupItvMarieNoelleLienemann', false)}
        ></PopupInterview>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationProcivis}
          open={!!popupsState.popupItvYannickBorde}
          onClose={() => onPopup('popupItvYannickBorde', false)}
        ></PopupInterview>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationAssociations}
          open={!!popupsState.popupItvDenisRambaud}
          onClose={() => onPopup('popupItvDenisRambaud', false)}
        ></PopupInterview>
      </div>
    );
  }
}

B5Federations.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  baseUrl: PropTypes.string,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(B5Federations);
